module.exports = __webpack_public_path__ + "static/media/latam-infinite.fa29ab3f.png";